import StandaloneChatPage from './standalone-chat-page'

export default StandaloneChatPage